<div class="wrapper">
  <div class="training-section section">
    <p class="section__title">{{ 'academy.academyTraining' | translate }}</p>
    <div class="section__content training-content">
      @for (course of courses; track course) {
        <a
          *appWithPermission="course.permission ?? []"
          class="academy-links-container__link"
          target="_blank"
          [href]="course.key | academyLink"
          (click)="courseClicked(course.key)">
          {{ 'academy.' + course.key | translate }}
          @if (!visitedCourses.has(course.key)) {
            <span class="academy-links-container__link-new">{{ 'academy.new' | translate }}</span>
          } @else {
            <span class="academy-links-container__link-read">
              {{ 'academy.read' | translate }}
              <mat-icon>check</mat-icon>
            </span>
          }
        </a>
      }
    </div>
  </div>
  <div class="download-section section">
    <p class="section__title">{{ 'academy.downloads' | translate }}</p>
    <div class="section__content download-content">
      @for (downloadLinkKey of downloadLinks; track $index) {
        @if ('academy.downloadLinks.' + downloadLinkKey + '.url' | translate; as url) {
          <a class="academy-links-container" target="_blank" [href]="url">
            <mat-icon color="primary">description</mat-icon>
            {{ 'academy.downloadLinks.' + downloadLinkKey + '.title' | translate }}
          </a>
        }
      }
    </div>
  </div>
</div>
